<template>
    <div class="main">
        <my_menu></my_menu>
        
        <div class="content">
            <Exception type="403" title="403" desc="您没有这个功能的访问权限哟~" back-text="返回首页" redirect="/" img-color />
        </div>
    </div>


</template>

<script>
import my_menu from '@/component/menu/menu.vue'

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度


        }
    },

    mounted() {
        this.window_change()

    },

    methods: {


        // //获取用户列表
        // get_user_list() {
        //     var that = this
        //     var obj = {
        //         page: this.page
        //     }
        //     this.table_loading = true
        //     http("post", process.env.VUE_APP_HOST + "/user_manage/user_list", obj, true).then(
        //         (res) => {
        //             if (res.code == 0) {
        //                 that.table_data = res.data.table_data
        //                 that.columns = res.data.columns

        //             } else {
        //                 that.$Message.error({
        //                     content: res.msg,
        //                     duration: 3,
        //                 });
        //             }
        //             that.table_loading = false
        //         }
        //     ).catch((res) => {
        //         that.table_loading = false

        //         console.log(res, '请求出错')
        //     })
        // },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    padding: 10px;
}
.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>